import { SCORECARD_GOAL_TYPE_METRIC } from 'constants/scorecards';

export interface GoalEditPermissionsInput {
  goalType?: string;
  allowScorecardOwnerEdits?: boolean;
  allowScorecardMetricPmOwnerEdits?: boolean;
  isRevOpsManager: boolean;
  isReviewCycleManager: boolean;
  hasRestrictionForTemplateGoal: boolean;
  isActiveOwnScorecard: boolean;
}

export interface GoalEditPermissions {
  canEdit: boolean;
  canEditSubgoalWeights: boolean;
  isMetricGoal: boolean;
}

export default function getGoalEditPermissions({
  goalType,
  allowScorecardOwnerEdits,
  allowScorecardMetricPmOwnerEdits,
  isRevOpsManager,
  isReviewCycleManager,
  hasRestrictionForTemplateGoal,
  isActiveOwnScorecard,
}: GoalEditPermissionsInput): GoalEditPermissions {
  const isMetricGoal = goalType === SCORECARD_GOAL_TYPE_METRIC;

  const hasOwnerEditPermission = isMetricGoal
    ? allowScorecardMetricPmOwnerEdits
    : allowScorecardOwnerEdits;

  const baseCanEdit =
    !hasRestrictionForTemplateGoal ||
    (isActiveOwnScorecard && Boolean(hasOwnerEditPermission));

  const canEditMetricGoal =
    Boolean(allowScorecardMetricPmOwnerEdits) ||
    Boolean(isRevOpsManager || isReviewCycleManager);

  const canEdit =
    isMetricGoal && !isActiveOwnScorecard
      ? baseCanEdit && canEditMetricGoal
      : baseCanEdit;

  const canEditSubgoalWeights =
    !isActiveOwnScorecard ||
    (isActiveOwnScorecard && Boolean(hasOwnerEditPermission));

  return { canEdit, canEditSubgoalWeights, isMetricGoal };
}
